<template>
    <div>
        <table class="table table-striped">
            <thead class="thead-color text-center">
                <th scope="col" v-for="(header, index) of headers" :key="index">
                    {{ $t(`${module}.datatable.header.${header}`) }}
                </th>
            </thead>
            <tbody class="text-center">
                <tr v-if="items.length === 0">
                    <td class="text-center" :colspan="headers.length">
                        {{ $t(`data_table.empty_datatable`) }}	
                    </td>
                </tr>
                <tr v-else v-for="(item, index) of items" :key="index">
                    <td v-for="(key, ind) of item" :key="ind">
                        {{ key }}
                    </td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script>
export default {
    props: {
        items: {
            type: Array,
            required: true
        },
        headers: {
            type: Array,
            required: true
        },
        module: {
            type: String,
            required: true
        }
    },
    data() {
        return {

        }
    }
}
</script>
<style>
    .thead-color {
        background: #005296;
        color: #fff;
    }
</style>